import React from 'react';
import { Redirect, Route } from 'react-router';

import DashboardLayout from '../Layouts/DashboardLayout';
import routeRules from './routeRules';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      localStorage.getItem('sessionId') ? (
        <DashboardLayout {...props} props={rest}>
          <Component {...props} props={rest} />
        </DashboardLayout>
      ) : (
        <Redirect
          to={{
            pathname: routeRules.landingPage,
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

export default PrivateRoute;
